import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  loginRequest: ["email", "password", "notificationToken", "locale"],
  loginSuccess: ["accessToken"],
  loginFailure: null,
  saveToken: ["accessToken"],
  resetData: null,
});

export const LoginTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  success: null,
  error: null,
  payload: null,
  email: null,
  password: null,
  notificationToken: null,
  locale: null,
});

/* ------------- Selectors ------------- */

export const LoginSelectors = {
  getData: (state: any) => state.login.data,
  getAccessToken: (state: any) => state.login.accessToken,
  isFetching: (state: any) => state.login.fetching,
  isSuccess: (state: any) => state.login.success,
  hasError: (state: any) => state.login.error,
  getEmail: (state: any) => state.login.email,
  getPassword: (state: any) => state.login.password,
  getNotificationToken: (state: any) => state.login.notificationToken,
  getLocale: (state: any) => state.login.locale,
};

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (
  state: any,
  { email, password, notificationToken, locale }: any
) => {
  // Handle both immutable and plain objects
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    email,
    password,
    notificationToken,
    locale,
    payload: null,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

// successful api lookup
export const success = (state: any, action: any) => {
  const { accessToken } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    accessToken,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

// Something went wrong somewhere.
export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

/** save token in localStorage - adapted for web */
export const saveToken = (state: any, action: any) => {
  const { accessToken } = action;
  if (typeof window !== 'undefined') {
    localStorage.setItem("accessToken", accessToken);
  }
  return state.merge ? state.merge({}) : state;
};

/** reset login data to initial state */
export const resetData = (state: any) => {
  return state.merge ? state.merge(INITIAL_STATE) : INITIAL_STATE;
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOGIN_REQUEST]: request,
  [Types.LOGIN_SUCCESS]: success,
  [Types.LOGIN_FAILURE]: failure,
  [Types.SAVE_TOKEN]: saveToken,
  [Types.RESET_DATA]: resetData,
});
